export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_09-EN-f1fad104a9d33449004e46e8251a74c2.webp";